module.exports = __webpack_public_path__ + "cf4a316ef4a98d61949dad47bf83722a.jpg";